import React from 'react';
import { ResetPasswordForm } from '@/components/auth/ResetPasswordForm';

export function ResetPassword() {
  return <ResetPasswordForm />;
}